import React from "react";
import Modal from "../../../components/Modal/Modal";
import styled from "styled-components";
import { SZTIcon2 } from "../../../components/Icons/SZTIcon2";
import { StakeDetailContent, TagStatus, TitleModalFilter } from "../style";
import {
  LabelFormPopupDetail,
  ValueFormPopupDetail,
} from "../../stake-detail/style";
import { MyButton } from "../../../components/Button/style";
import { formatMoney, getClassStatustItemStake } from "../../../utils/hepler";
import moment from "moment";
import { FORMAT_DATE } from "../../stake-detail";
import { useApp } from "../../../contexts";
import FormButton from "../../../components/FormCustom2/Button";
import { Divider } from "antd";
import { useWindowSize } from "../../../hook/useWindowSize";
import { SGTIcon } from "../../../components/Icons/SGTIcon";
const ModalContainer = styled(Modal.Container)`
  padding: 52px 63px;
  width: 780px;
  background: #f5f5f5;
  @media (max-width: 1024px) {
    padding: 42px 16px 50px 16px;
  }
`;

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const TextAmount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  color: #000000;
  @media (max-width: 640px) {
    margin-top: 16px;
    font-weight: 500;
    font-size: 30px;
    line-height: 36px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #000000;
  }
`;

const TextTitle1 = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  color: #000000;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const ModalDetailStake = ({ onClose, onBack, data }) => {
  const { T } = useApp();
  const classStatus = getClassStatustItemStake(data);
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  return (
    <Modal>
      <Modal.ModalBg onClose={onClose} />
      <ModalContainer onClose={onClose}>
        <ContentWaper>
          <TitleModalFilter>
            {T("SGT Staking Order")} {data?.id}
          </TitleModalFilter>
          <div className="text-center mt-[40px] lg:mt-[35px] flex flex-col lg:flex-row lg:gap-[20px] items-center justify-center">
            <SGTIcon width={isMobile ? 68 : 80} height={isMobile ? 68 : 80} />
            <div>
              <TextAmount>{formatMoney(data?.amount)}</TextAmount>
              <TextTitle1>{T("Staked SGT")}</TextTitle1>
              <div className="flex justify-center mt-[16px] lg:mt-[5px]">
                <TagStatus className={classStatus}>{T(classStatus)}</TagStatus>
              </div>
            </div>
          </div>

          <StakeDetailContent className="flex flex-col mt-[50px] lg:mt-[50px]">
            <div className="flex gap-[12px]">
              <LabelFormPopupDetail>{T("Order ID")}</LabelFormPopupDetail>
              <ValueFormPopupDetail>{data?.id}</ValueFormPopupDetail>
            </div>
            <div className="flex gap-[12px]">
              <LabelFormPopupDetail>{T("Staking Term")}</LabelFormPopupDetail>
              <ValueFormPopupDetail>
                {data?.year} {T(data?.label)}
              </ValueFormPopupDetail>
            </div>
            <div className="flex gap-[12px]">
              <LabelFormPopupDetail>{T("Effective Date")}</LabelFormPopupDetail>
              <ValueFormPopupDetail>
                {moment(data?.timeStartStake)?.format(FORMAT_DATE)}
              </ValueFormPopupDetail>
            </div>
            <div className="flex gap-[12px]">
              <LabelFormPopupDetail>{T("Maturity Date")}</LabelFormPopupDetail>
              <ValueFormPopupDetail>
                {moment(data?.timeStartStake + data?.duration)?.format(
                  FORMAT_DATE
                )}
              </ValueFormPopupDetail>
            </div>
            <div className="flex gap-[12px]">
              <LabelFormPopupDetail style={{ minWidth: 130 }}>
                {T("xSGT Voting Power")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>
                {formatMoney((data?.amount * data?.ratioGetTokenStaking) / 100)}
              </ValueFormPopupDetail>
            </div>
          </StakeDetailContent>
          <Divider className="mt-[54px] hidden lg:block" />
          <div className="flex gap-4 mt-[46px] justify-center">
            <FormButton width={ isMobile ? 280 : 170} className="primary2" onClick={onBack}>
              {T("Back")}
            </FormButton>
          </div>
        </ContentWaper>
      </ModalContainer>
    </Modal>
  );
};

export default ModalDetailStake;
